import { Component, inject, input, output, signal } from '@angular/core';
import { TextInput } from '@/shared/components';
import { BotConfigService } from '@/features/chat/services';

@Component({
  selector: 'bevvi-chat-footer',
  imports: [TextInput],
  templateUrl: './chat-footer.html',
  styleUrl: './chat-footer.css',
})
export class ChatFooter {
  public readonly loading = input(false);

  public readonly value = signal('');
  public readonly send = output<string>();

  protected readonly placeholder = inject(BotConfigService).config;

  public onSend(): void {
    const message = this.value().trim();
    if (!message) return;
    this.send.emit(message);
    this.value.set('');
  }
}
